const defaultCustomerSupportImage = `${process.env.PUBLIC_URL}/images/default-user-icon.svg`

const getImageFromCustomerSupport = customerSupportDetails => {
  return customerSupportDetails.imageUrl || defaultCustomerSupportImage
}

export const getMessageLogo = (message, settings) => {
  return message?.customerSupportDetails
    ? getImageFromCustomerSupport(message.customerSupportDetails)
    : settings.logo
}
